export default __webpack_public_path__ + "static/media/tree5.52284aa6.png";